import type { ReactNode } from "react";

type TagTone = "primary" | "accent" | "secondary" | "neutral";

interface TagProps {
  children: ReactNode;
  tone?: TagTone;
  className?: string;
}

const toneMap: Record<TagTone, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-800",
  neutral: "bg-background-200 text-foreground-700",
};

export default function Tag({ children, tone = "secondary", className = "" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-label font-medium ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}